<template>
  <Card :bordered="false" :padding="padding" :shadow='true' class="homepagecard">
    <p slot="title">{{title}}</p>
    <a class="hompage-card-extra" v-if="extra" href="javascript:void(0)" @click="$emit('extraClick')" slot="extra">{{extra}}</a>
    <slot></slot>
  </Card>
</template>
<script>
  export default {
      props: {
          title: {
              type: String,
              required: true
          },
          padding: {
              type: Number,
              default: 20
          },
          extra: {
              type: String,
              default: null
          }
      }
  };
</script>
<style lang="postcss" type="text/postcss">
.homepagecard {
  &.tbo-card-shadow {
    box-shadow: 0 10px 25px 0 #f1f3f7, 0 2px 7px 0 #eff3f8;
    &:hover {
      box-shadow: 0 10px 25px 0 #f1f3f7, 0 2px 7px 0 #eff3f8;
    }
  }
  .hompage-card-extra {
    color: #60666e;
    &:hover,
    &:focus {
      color: #37a6fc;
      text-decoration: none;
    }
  }
  .tbo-card-head {
    box-shadow: inset 0 -0.5px 0 0 #dce3ea;
    border-bottom: none;
    padding: 14px 20px;
    p {
      font-size: 16px;
      font-weight: 500;
      color: #333d48;
      line-height: 22px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// Card.vue?05a20648